import { render, staticRenderFns } from "./supplierListing.vue?vue&type=template&id=8e801890&"
import script from "./supplierListing.vue?vue&type=script&lang=js&"
export * from "./supplierListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports